﻿import React from 'react';
import { connect } from 'react-redux';
import { VeilederLutAppState } from '../Store';
import { toggleModal } from '../Store/Valg/Actions';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import * as ValgTypes from '../Store/Valg/Types';

interface ModalKlikkPropsOwnProps {
    valg: ValgTypes.ValgState;
    lenketekst: JSX.Element | null;
    overskrift: JSX.Element | null;
    content: JSX.Element | null;
    ariaLabel: string;
}

type ModalKlikkProps = MapStateToProps & MapDispatchToProps & ModalKlikkPropsOwnProps;

class ModalKlikkComponent extends React.PureComponent<ModalKlikkProps> {
    constructor(props: ModalKlikkProps) {
        super(props);
        this.onModalClick = this.onModalClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleModal();
    }

    onModalClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleModal();
    }

    render(): JSX.Element {
        const { visModal, lenketekst, overskrift, content, ariaLabel } = this.props;

        return (
            <div className="c-veileder__panel-row c-veileder__content-custom">
                <div className="c-veileder__content c-veileder__content--linkarea">
                    <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onModalClick}>
                        {lenketekst}
                    </button>
                    <ModalCompontent isOpen={visModal} onRequestClose={this.onRequestClose} ariaCloseText={ariaLabel}>
                        <ArticleContentComponent headerinnhold={overskrift} contentinnhold={content} />
                    </ModalCompontent>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    visModal: boolean;
}

interface MapDispatchToProps {
    toggleModal: typeof toggleModal;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederLutAppState): MapStateToProps => {
        return {
            visModal: state.valg.visModal,
        };
    },
    { toggleModal, updateZIndex },
)(ModalKlikkComponent);
